import InputText from 'bloko/blocks/inputText';

import useTrls from 'hooks/translation/useTrls';

import ClickmeFormItem from 'components/ClickmeFormItem';

import { setPayerLegalAddress } from 'store/models/payerCreate';
import { useDispatch, useSelector } from 'store/utils';

const PayerLegalAddress = () => {
    const dispatch = useDispatch();
    const { payerLegalAddress, payerErrors } = useSelector((state) => state.payerCreate);
    const trl = useTrls();

    return (
        <ClickmeFormItem
            input={
                <InputText
                    value={payerLegalAddress}
                    onChange={(value) => dispatch(setPayerLegalAddress(value))}
                    placeholder={trl('InvoiceAndPayerForm.PayerCreate.PayerLegalAddress.placeholder')}
                    invalid={Boolean(payerErrors.address)}
                    data-qa="address"
                />
            }
            legend={trl('InvoiceAndPayerForm.PayerCreate.PayerLegalAddress.legend')}
            isRequired
            error={payerErrors.address}
        />
    );
};

export default PayerLegalAddress;
